'use client';
import React from 'react';
import { Check, Sparkles } from 'lucide-react';

export const TTOSComparisonV3: React.FC = () => {
  const comparisonRows = [
    {
      feature: 'Setup Time',
      agency: '3 to 6 Weeks',
      diy: '40+ Hours of trial & error',
      ttos: '2 Minutes Instant',
    },
    {
      feature: 'Monthly Cost',
      agency: '₹35,000 – ₹1,50,000+',
      diy: '₹12,000 for 8 separate tools',
      ttos: 'Starting at ₹999/mo',
    },
    {
      feature: 'Industry Specialization',
      agency: 'Generic junior copywriters',
      diy: 'Must teach yourself prompts',
      ttos: 'Pre-trained for 40+ Indian Trades',
    },
    {
      feature: 'Website & SEO Builder',
      agency: 'Charges extra ₹25,000/site',
      diy: 'Complex WordPress maintenance',
      ttos: 'Included with 1-Click Publishing',
    },
    {
      feature: 'WhatsApp & Social Autopilot',
      agency: 'Manual scheduling delays',
      diy: 'Switch between 5 browser tabs',
      ttos: 'Autonomous 24/7 Publishing',
    },
    {
      feature: 'Lead Follow-up Speed',
      agency: 'Next business day (often lost)',
      diy: 'Manual typing on phone',
      ttos: '< 60 Seconds Autonomous AI Bot',
    },
  ];

  return (
    <section className="py-20 bg-white border-t border-slate-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto space-y-2 mb-12">
          <h2 className="text-2xl sm:text-3xl font-extrabold text-slate-900 tracking-tight">
            Why Modern Businesses Choose TT OS
          </h2>
          <p className="text-sm text-slate-500">
            See how the AI Business Operating System compares to legacy options.
          </p>
        </div>

        {/* Comparison Table */}
        <div className="max-w-5xl mx-auto overflow-x-auto rounded-3xl border border-slate-200 shadow-lg">
          <table className="w-full text-left text-xs sm:text-sm border-collapse bg-white">
            <thead>
              <tr className="border-b border-slate-200 bg-slate-50 text-slate-700">
                <th className="p-4 sm:p-5 font-bold">Platform Capability</th>
                <th className="p-4 sm:p-5 font-bold text-slate-500">Traditional Agency</th>
                <th className="p-4 sm:p-5 font-bold text-slate-500">DIY Prompt Tools</th>
                <th className="p-4 sm:p-5 font-extrabold text-indigo-700 bg-indigo-50/70 border-x border-indigo-200">
                  <div className="flex items-center gap-1.5">
                    <Sparkles className="w-4 h-4 text-indigo-600" />
                    <span>TT OS Business Platform</span>
                  </div>
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100 text-slate-600 font-medium">
              {comparisonRows.map((row, idx) => (
                <tr key={idx} className="hover:bg-slate-50/60 transition-colors">
                  <td className="p-4 sm:p-5 font-bold text-slate-900">{row.feature}</td>
                  <td className="p-4 sm:p-5 text-slate-500">{row.agency}</td>
                  <td className="p-4 sm:p-5 text-slate-500">{row.diy}</td>
                  <td className="p-4 sm:p-5 font-bold text-indigo-900 bg-indigo-50/40 border-x border-indigo-100">
                    <div className="flex items-center gap-2 text-indigo-700">
                      <Check className="w-4 h-4 text-emerald-600 shrink-0" />
                      <span>{row.ttos}</span>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

      </div>
    </section>
  );
};

export default TTOSComparisonV3;
